import { HiOutlineMail } from "react-icons/hi";
import { FaTelegram, FaFacebookMessenger } from "react-icons/fa";

const data = [
  {
    id: 1,
    icon: <HiOutlineMail />,
    link: "mailto:sokmasterlychanon06@gmail.com",
  },
  {
    id: 2,
    icon: <FaFacebookMessenger />,
    link: "https://m.me/masterly.chanon",
  },
  { id: 3, icon: <FaTelegram />, link: "https://t.me/sokmasterly" },
];

export default data;
